import React from 'react'
import { Route, Switch } from 'react-router-dom'
import TabBar from '@zambezi/sdk/tab-bar'
import { findIndex, pipe } from 'ramda'
import { followStoreLink$ } from '../navigation'

import PageHeader from './PageHeader'
import NavBar from './NavBar'

import PayMe from './PayMe'
import PayYou from './PayYou'

import layoutStyle from '../common/api-enabler-styles.module.css'

export default function PayMeYou({ rootPath, type }) {
  const tabData = [
    {
      title: 'Pay Me',
      id: 'pay-me',
    },
    {
      title: 'Pay You',
      id: 'pay-you',
    },
  ]

  const selectedTabIndex = pipe(
    findIndex(tab => tab.id === type),
    index => (index === -1 ? 0 : index)
  )(tabData)

  return (
    <section>
      <PageHeader
        navbar={<NavBar />}
        title="Pay Me / Pay You"
        subtitle="Payment links I'm sharing"
      />
      <div className={layoutStyle.overviewSections}>
        <TabBar
          className="ob-tab-bar"
          data={tabData}
          selectedIndex={selectedTabIndex}
          onSelected={({ id }) => {
            followStoreLink$.next(`/paymeyou/${id}`)
          }}
          renderFn={tab => tab.title}
        />

        <Switch>
          <Route
            path={`${rootPath}/paymeyou/pay-you`}
            exact
            render={() => <PayYou />}
          />
          <Route
            path={`${rootPath}/paymeyou/pay-me`}
            exact
            render={() => <PayMe />}
          />
        </Switch>
      </div>
    </section>
  )
}
